import { render, staticRenderFns } from "./productSelection.vue?vue&type=template&id=6d4a16e1"
import script from "./productSelection.vue?vue&type=script&lang=js"
export * from "./productSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports